var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('template-administrator',[_c('div',{attrs:{"slot":"container"},slot:"container"},[_c('table-groups')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }